import { useEffect } from 'react';
import { ApolloError } from '@apollo/client/errors';
import { useAuth } from 'context/AuthContext';

export const useHandleError = (error: ApolloError | undefined) => {
  const { logout } = useAuth();

  useEffect(() => {
    if (error) {
      const isForbidden =
        error.networkError && 'statusCode' in error.networkError ? error?.networkError?.statusCode === 403 : false;

      if (isForbidden) {
        console.log('Access denied! Please login again');
        logout();
      } else {
        console.log('Something went wrong: ', error.message);
      }
    }
  }, [error]);
};
